/* eslint-disable */
export default ({
	Title,
    Summary,
    Url,
	Client,
	ListingTags,
    ThumbnailImageUrlLarge: Thumbnail,
    ThumbnailAlt,
}) => `
<article class="col-12 col-sm-12 col-lg-6 col-xl-6 c-article-listing__item c-article-listing__item--hidden c-article-listing__item--case-study">
    <a href="${Url}" title="${Client}" class="c-content-block">
        ${
            Thumbnail ? `
                <picture class="c-content-block__image">
                    <img src="${Thumbnail}" alt="${ThumbnailAlt}" loading="lazy" />
                </picture>
            ` : ''
        }
        <div class="c-content-block__content-wrapper">
		     <div class="c-content-block__meta">
				${
                    ListingTags ? `${ListingTags.map(function (e) {return e["Value"]}).join(', ')}` : ''
                }
            </div>
            ${
                Title ? `
                    <h3 class="c-content-block__copy">${Title}</h3>
                `
                : ''
            }
            ${
                Client ? `
                    <p class="c-content-block__summary">${Client}</p>
                `
                : ''
            }
        </div>
    </a>
</article>`;
/* eslint-enable */
